// extracted by mini-css-extract-plugin
export default {"button":"---------packages-corgi-x-src-components-CollapsibleCard-ToggleButton-module__button"};